<template>
  <div id="author" v-if="isAuthed" class="transparent">
    <auth-navigator ref="navigator"></auth-navigator>
    <auth-toolbar @emit="emitted"></auth-toolbar>
    <v-content>
      <v-container app fill-height>
        <router-view></router-view>
      </v-container>
    </v-content>
  </div>
</template>

<script>
import io from 'socket.io-client'
import AuthToolbar from './toolbar'
import AuthNavigator from './navigator'

export default {
  name: 'author',
  components: {
    AuthToolbar,
    AuthNavigator
  },
  data () {
    return {
      config: {
        status: {
          authed: false
        }
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init: function () {
      this.$firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          this.$author.auth(user).then(res => {
            this.$store.commit('config/update', { authors: res.authors })
            this.$store.commit('author/update', res.author)
            this.$set(this.config.status, 'authed', true)
          }).catch(err => {
            console.log(err)
            this.unauthed()
          })
        } else {
          this.unauthed()
        }
      })
    },
    unauthed: function () {
      let qs = this.$route.query
      this.$router.push({
        path: '/login',
        query: {
          redirect: 'redirect' in qs ? qs.redirect : this.$route.fullPath
        }
      })
    },
    emitted: function (req) {
      if (
        req &&
        req.dest &&
        req.action &&
        this.$refs[req.dest] &&
        typeof this.$refs[req.dest][req.action] === 'function'
      ) {
        this.$refs[req.dest][req.action](req.data)
      }
    }
  },
  computed: {
    isAuthed () {
      return this.config.status.authed
    }
  }
}
</script>

<style lang="scss">
#author {
  width: 100%;
  min-height: 100vh;
  .v-content {
    min-height: 100vh;
    .container.app {
      & > main {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
